import { createSlice } from '@reduxjs/toolkit';
import { getInsights } from '../../../rtk-apis/dashboard/getInsights';

const initialState = {
  status: '',
  result: null as any,
  msg: '',
  loading: false,
  error: '',
};

const getInsightsSlice = createSlice({
  name: 'getInsights',
  initialState,
  reducers: {
    clearState: state => {
      state.status = '';
      state.result = null;
      state.msg = '';
      state.loading = false;
      state.error = '';
    },
  },
  extraReducers: builder => {
    builder
      .addCase(getInsights.pending, state => {
        state.loading = true;
      })
      .addCase(getInsights.fulfilled, (state, action) => {
        state.loading = false;
        state.status = 'SUCCESS';
        state.result = action?.payload;
        state.msg = action?.payload?.msg;
      })
      .addCase(getInsights.rejected, (state, action) => {
        state.loading = false;
        state.status = 'ERROR';
        state.result = null;
        state.msg = (action?.payload as string) || 'Something went wrong!';
      });
  },
});

export default getInsightsSlice.reducer;
export const { clearState } = getInsightsSlice.actions;
